<template>
  <CloseHeader @close="goToMain" />

  <div class="app-container one-page">
    <div class="fst-step-con">
      <div class="gauge-bar">
        <span class="bar-bg"></span>
        <span class="active"></span>
      </div>
      <div class="inr-con">
        <h1>
          <i18n-t keypath="select_interpretation_title">
            <template #interpretation>
              <span class="primary">{{ t('label_interpretation') }}</span>
            </template>
          </i18n-t>
        </h1>
        <InterpretationList v-model="selectedChatType"></InterpretationList>
      </div>
    </div>

    <div class="app-btn-wrap">
      <button type="button" class="primary-btn l-btn" :disabled="!selectedChatType" @click="goToNextStep">
        <span>{{ t('button_voice_register') }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import CloseHeader from '@/components/domains/mobile/common/CloseHeader.vue';
import InterpretationList from '@/components/domains/mobile/InterpretationList.vue';
import { TypeCall } from '@/types/common';

const selectedChatType = ref<TypeCall>('MEETING');

const { t } = useI18n();
const router = useRouter();

const goToMain = () => {
  router.replace({ name: 'app-main-view' });
};

const goToNextStep = () => {
  router.replace(`/app/chat/new/${selectedChatType.value?.toLowerCase()}`);
};
</script>

<style scoped lang="scss">
.fst-step-con {
  .gauge-bar {
    position: relative;
    padding: 1rem 0;
    .bar-bg {
      display: block;
      background: $gray10;
      border-radius: 100px;
      height: $size-s;
      width: 100%;
    }
    .active {
      background: $color-gray-900;
      width: 100%;
      height: $size-s;
      position: absolute;
      left: 0;
      top: 1rem;
      border-radius: 100px;
    }
  }
  .inr-con {
    h1 {
      font-size: 1.5rem;
      padding: 2rem 0 1.5rem;
      line-height: 130%;
      span {
        font-size: 1.5rem;
        line-height: 130%;
      }
    }
  }
}
.app-btn-wrap {
  padding-bottom: 1.25rem;
  button {
    width: 100%;
  }
}
</style>
